module.exports = __webpack_public_path__ + "static/media/end_of_the_jetty_small.2484a56e.jpg";